export default __webpack_public_path__ + "static/media/4103.99d1f6ab.png";